import * as React from 'react';
import { UIText2 } from '@cian/ui-kit';
import { clsx } from 'clsx';

import styles from './ContentRow.css';

interface IProps {
  label: string;
  children: React.ReactNode;
  vertical?: boolean;
  boldLabel?: boolean;
  fullWidth?: boolean;
  dataTestid?: string;
}

export const ContentRow = (props: IProps) => {
  const { label, children, vertical, boldLabel = true, fullWidth, dataTestid } = props;

  const isStringContent = typeof children === 'string' || typeof children === 'number';

  return (
    <div
      data-testid={dataTestid}
      className={clsx(styles.wrapper, vertical && styles.vertical, fullWidth && styles.full_width)}
    >
      <div className={styles.label}>
        <UIText2 fontWeight={boldLabel ? '600' : undefined}>{label}:</UIText2>
      </div>
      {isStringContent ? (
        <UIText2 whiteSpace="normal">{children}</UIText2>
      ) : (
        <div className={styles.content}>{children}</div>
      )}
    </div>
  );
};
